function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.88 42.033C61.88 51.3533 52.6019 61.0555 33.9541 68C15.398 61.0555 6.12 51.3533 6.12 42.033C6.12 32.7126 6.12 21.0164 6.12 7.03596C18.6131 2.37578 27.8912 0 33.9541 0C40.017 0 49.3869 2.37578 61.88 7.03596C61.88 21.0164 61.88 32.7126 61.88 42.033Z",
  fill: "#E7EAF2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M67.2359 31.2997C64.3702 31.6722 61.8865 32.417 59.4983 33.2551C57.1103 34.0932 54.9132 35.1174 52.7162 36.1417C52.4297 36.3278 52.1431 36.421 51.8565 36.6073C50.1371 34 48.3222 31.4859 46.1251 29.0649C43.8325 26.4576 41.3489 24.0366 38.5786 21.7087C35.7129 19.474 32.7517 17.2392 28.9308 15.47L27.88 16.0287C29.4083 19.0084 30.9368 21.9881 32.5606 24.8747L37.3369 33.7207L42.2086 42.4735C42.2086 42.5666 45.8385 48.8053 47.1759 51.2264L47.94 52.53L48.8952 51.4126L53.7669 46.6636C54.1491 46.2913 57.7789 42.6598 58.5431 41.8217C60.1671 40.2387 61.6954 38.6558 63.3194 36.9798L68 32.0445L67.2359 31.2997Z",
  fill: "#3DDBB6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.59 30.94C52.2101 30.94 49.47 28.1999 49.47 24.82C49.47 21.4401 52.2101 18.7 55.59 18.7C58.9699 18.7 61.71 21.4401 61.71 24.82C61.71 28.1999 58.9699 30.94 55.59 30.94Z",
  fill: "#3DDBB6"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.764191 31.2997C3.62991 31.6722 6.11352 32.417 8.50162 33.2551C10.8897 34.0932 13.0868 35.1174 15.2838 36.1417C15.5704 36.3278 15.857 36.421 16.1435 36.6073C17.8629 34 19.6778 31.4859 21.8749 29.0649C24.1675 26.4576 26.6511 24.0366 29.4214 21.7087C32.2871 19.474 35.2483 17.2392 39.0692 15.47L40.12 16.0287C38.5917 19.0084 37.0632 21.9881 35.4394 24.8747L30.6631 33.7207L25.7914 42.4735C25.7914 42.5666 22.1615 48.8053 20.8242 51.2264L20.06 52.53L19.1048 51.4126L14.2331 46.6636C13.851 46.2913 10.221 42.6598 9.45686 41.8217C7.83296 40.2387 6.30457 38.6558 4.68066 36.9798L0 32.0445L0.764191 31.2997Z",
  fill: "#002175"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.41 30.94C15.79 30.94 18.53 28.1999 18.53 24.82C18.53 21.4401 15.79 18.7 12.41 18.7C9.03001 18.7 6.29 21.4401 6.29 24.82C6.29 28.1999 9.03001 30.94 12.41 30.94Z",
  fill: "#002175"
});

var SvgClubesLogo = function SvgClubesLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClubesLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clubes-logo.ed3360d9.svg";
export { ForwardRef as ReactComponent };